$(document).ready(function () {
    //toggle the component with class accordion_body
    $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });

    $('.bundle-products-wrapper').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });
    $('.custom_main_slides').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });

    $('.books-wrapper-slider').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });

     $('.main-related-items').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
                adaptiveHeight: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                adaptiveHeight: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
            }
        }
    ]
});
$('.collections-slides').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });

    $('.swiper-wrapper').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });
$('.custom-collection-slides').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });

    $('.custom-multicolumn-slides').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
        }
    ]
    });
    function initMobileSlider() {
    
    if ($(window).width() <= 767) {

      if (!$('.custom-mobile-slider').hasClass('slick-initialized')) {

        $('.custom-mobile-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: true
        });

      }

    } else {

      if ($('.custom-mobile-slider').hasClass('slick-initialized')) {
        $('.custom-mobile-slider').slick('unslick');
      }

    }
  }

  initMobileSlider();

  $(window).on('resize', function () {
    initMobileSlider();
  });
 if (window.innerWidth < 768) {
    jQuery('.accordion_container').insertBefore('div#shopify-section-footer');
}
});

document.addEventListener('DOMContentLoaded', function(){

  const bundleCards = document.querySelectorAll('.bundle-product-card');

  bundleCards.forEach(card => {

    const addBtn = card.querySelector('.bundle-add-btn');
    const viewCartBtn = card.querySelector('.bundle-view-cart');

    addBtn.addEventListener('click', function(){

      const variantId = this.dataset.variantId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {

        addBtn.classList.add('hidden');
        viewCartBtn.classList.remove('hidden');

      });

    });

  });
if ($('body').hasClass('template-product')) {

  const moveTestimonials = setInterval(function () {

    if ($('#testimonials').length && $('.custom-review').length) {

      $('#testimonials').appendTo('.custom-review');

      clearInterval(moveTestimonials);
    }

  }, 500);

}


  var $slider = $('#slideshow-index-slideshow');

  if ($slider.length) {

    // Create wrapper div
    $slider.append('<div class="custom-slider-arrows"></div>');

    // Move arrows inside wrapper
    $slider.find('.slick-prev, .slick-next')
      .appendTo($slider.find('.custom-slider-arrows'));

  }

});
jQuery(function ($) {
    $('.cards-scroll').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3
                }
            },
              {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

$(window).on('scroll', function () {
  if ($(window).scrollTop() > 50) {
    $('header').addClass('scrolled');
  } else {
    $('header').removeClass('scrolled');
  }
});

$('.menuToggle').on('click', function () {
    const isExpanded = $(this).attr('aria-expanded') === 'true';

    if (isExpanded) {
        $('body').addClass('menu-open');
    } else {
        $('body').removeClass('menu-open');
    }
});


$(document).ready(function () {

  // Open first FAQ by default
  $('.faq-item:first').addClass('active');
  $('.faq-item:first .faq-answer').show();
  $('.faq-item:first .faq-question').attr('aria-expanded', 'true');

  $('.faq-question').on('click', function () {

    var $item = $(this).closest('.faq-item');
    var $answer = $item.find('.faq-answer');

    // If already open, do nothing
    if ($item.hasClass('active')) {
      return;
    }

    // Close all
    $('.faq-item').removeClass('active');
    $('.faq-answer').slideUp(300);
    $('.faq-question').attr('aria-expanded', 'false');

    // Open current
    $item.addClass('active');
    $answer.stop(true, true).slideDown(300);
    $(this).attr('aria-expanded', 'true');

  });

$(document).on('click', '.fera.fera-widget.fera-productRating-widget', function(e) {
    e.preventDefault();

    var offset = 150; // Change this value as needed

    $('html, body').animate({
        scrollTop: $('#reviews-scroll').offset().top - offset
    }, 500);
});

function updateCartCount() {
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function(cart) {
            console.log('Cart Count:', cart.item_count);

            // Update your cart count here
            $('span.cartCost').text(cart.item_count);
        }
    });
}

// Trigger after any cart AJAX request
$(document).ajaxComplete(function(event, xhr, settings) {

    if (
        settings.url.indexOf('/cart/add') !== -1 ||
        settings.url.indexOf('/cart/change') !== -1 ||
        settings.url.indexOf('/cart/update') !== -1 ||
        settings.url.indexOf('/cart/clear') !== -1
    ) {
        updateCartCount();
    }

});
});
